/**
 *
 * @module subscriptionManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class SubscriptionManagerConfiguration
 * @desc Provides configuration information necessary for managing subscriptions.
 *
 */
export default class SubscriptionManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/subscriptionManagerConfiguration.js